import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { InputGroup, FormControl } from 'react-bootstrap';

import { Form } from 'ui/components';
import { formatDate } from 'utilities/common';
import { SkeletonText, SkeletonTable } from 'ui/components/skeleton';
import { ShipmentCustomer } from 'services/action';

import * as Fi from 'react-icons/fi';
import cn from 'classnames';
// import _ from 'underscore';

const initialState = {
  search: '',
  shipments: [],
  // checkedAll: false
};

export const FormShipments = ({
  data,
  onChange,
  customer,
  service,
}) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const isLoading = useSelector(
    (state) => state?.Activity?.services['Order.Get']
  );

  const [{ search, shipments }, setState] = React.useState(initialState);

  // const $handleCheckedAll = async (e) => {
  //   let newItems = [...shipments];

  //   _.each(newItems, function(i) {
  //     i.checked = checkedAll ? false : true
  //   })

  //   setState((prevState) => ({ ...prevState, shipments: newItems, checkedAll: checkedAll ? false: true }));
  // }

  const $handleItemsChange = async (i, e) => {
    let newItems = [...shipments];

    newItems[i]['checked'] = shipments[i].checked ? false : true;

    setState((prevState) => ({ ...prevState, shipments: newItems }));
  };

  const queryArea = () => {
    let query = {
      page: 1,
      limit: 100000000,
      document_status: 'new',
      customer_id: customer?.id,
      order_by: '-created_at',
      search: search
    };

    return query;
  };

  const $setup = async () => {
    const so = await $setupShipments();

    setState((prevState) => ({ ...prevState, shipments: [...so] }));
  }

  const $setupShipments = async () => {
    const res = await Dispatch(ShipmentCustomer.$get(queryArea()));

    if (res && res?.message === 'success') {
      let newData = [];

      await res?.data?.forEach((data) => {
        const payload = {
          shipment_customer_id: data?.id,
          ref_code: data?.ref_code,
          origin_id: data?.pickup_address?.id,
          pickup_address: data?.pickup_address,
          destination_id: data?.recipient?.id,
          recipient: data?.recipient,
          pickup_note: data?.pickup_note,
          instruction: data?.instruction,
          cod_value: data?.cod_value,
          etd_at: formatDate(data?.etd_at, 'YYYY-MM-DD HH:mm Z'),
          eta_at: formatDate(data?.eta_at, 'YYYY-MM-DD HH:mm Z'),
          code: data?.code,
          total_quantity: data?.total_quantity || 1,
          items: data?.items,
          checked: false,
        };

        let now = new Date()

        if (payload?.eta_at === '-') {
          payload.eta_at = formatDate(formatDate(now.setDate(now.getDate() + 1), 'YYYY-MM-DD') + " 23:59", 'YYYY-MM-DD HH:mm Z')
        }

        if ((service?.id === '61bb02262a457fc68763b774') && data?.items === null) {
          payload.items = [{"item_name": "-", "quantity": 1}]
        }

        newData?.push(payload);
      });

      return newData
    }

    return []
  };

  React.useEffect(() => {
    let newShipments = [];

    if (shipments) {
      shipments?.forEach((shipment) => {
        if (shipment?.checked) {
          newShipments.push(shipment);
        }
      });
    }

    onChange(newShipments);
  }, [shipments]);

  React.useEffect(() => {
    if (!customer) {
      setState((prevState) => ({ ...prevState, shipments: [] }));
    } else {
      $setup();
    }
  }, [customer, search])

  if (!shipments || shipments?.length === 0) {
    return (
      <div className="row">
        <div className="empty col-lg-12 truck">
          <div className="truck-wrapper">
            <div className="truck">
              <div className="truck-container"></div>
              <div className="glases"></div>
              <div className="bonet"></div>
              <div className="base"></div>
              <div className="base-aux"></div>
              <div className="wheel-back"></div>
              <div className="wheel-front"></div>
              <div className="smoke"></div>
            </div>
          </div>
          <p className="empty-title">
            {!customer ? 'Customer belum dipilih' : 'Hasil tidak ditemukan'}
          </p>
          {!customer ? (
            <p className="empty-subtitle text-muted">
              Silakan pilih customer terlebih dahulu. <br /> Daftar shipment
              yang belum dibuatkan order akan muncul disini.
            </p>
          ) : (
            <p className="empty-subtitle text-muted">
              Coba sesuaikan pencarian atau filter Anda untuk menemukan apa yang
              Anda cari.
              <br /> Atau mungkin belum ada datanya!
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="col-12 px-3 bg-white">
        <div>
          <div
            className="fw-semibold py-2 border-bottom mb-3"
            style={{ fontSize: 13 }}
          >
            {isLoading ? (
              <div style={{ width: 250 }}>
                <SkeletonText count={1} />
              </div>
            ) : (
              <>
                <div className='d-flex justify-content-between'>
                  <div className='col-8'>
                    <span>Daftar Shipment</span>
                  </div>
                  <div className='col-4'>
                    <InputGroup className="search flex-nowrap input-group-flat bg-light">
                      <FormControl
                        placeholder="Cari ..."
                        value={search}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            search: e.target.value,
                          }))
                        }
                        className="bg-light"
                      />
                      <div className="input-group-text">
                        {search ? (
                          <Fi.FiX
                            onClick={() =>
                              setState((prevState) => ({
                                ...prevState,
                                search: '',
                              }))
                            }
                          />
                        ) : (
                          <Fi.FiSearch />
                        )}
                      </div>
                    </InputGroup>
                  </div>
                </div>
              </>

            )}
          </div>
          {isLoading ? (
            <SkeletonTable headerCount={6} bodyCount={10} />
          ) : (
            <>
              <div className="table-responsive m-0" style={{maxHeight: '550px'}}>
                <table
                  width="100%"
                  className={cn(
                    'table table-hover table-vcenter card-table datatable border',
                    StateForm?.errors?.shipments ? 'border-danger' : ''
                  )}
                >
                  <thead className="bg-light">
                    <tr className="th">
                      <td style={{ whiteSpace: 'initial', width: '50px' }}>
                        {/* {shipments && (
                          <Form.Checkbox
                            value={checkedAll}
                            onChange={(e) => $handleCheckedAll(e)}
                            iconSize={18}
                          />
                        )} */}
                        &nbsp;
                      </td>
                      <td style={{ whiteSpace: 'initial', width: '200px' }}>
                        Kode
                      </td>
                      <td
                        style={{
                          whiteSpace: 'initial',
                          width: '200px',
                        }}
                      >
                        Origin
                      </td>
                      <td
                        style={{
                          whiteSpace: 'initial',
                          width: '200px',
                        }}
                      >
                        Destination
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {shipments?.map((s, i) => (
                      <tr
                        key={i}
                        className={cn(
                          StateForm?.errors[`shipments.${i}.shipment_customer_id`]
                            ? 'text-danger border-danger'
                            : null
                        )}
                      >
                        <td style={{ whiteSpace: 'initial', width: '50px' }}>
                          <Form.Checkbox
                            onChange={(e) => $handleItemsChange(i, e)}
                            value={s?.checked}
                            iconSize={18}
                          />
                        </td>
                        <td style={{ whiteSpace: 'initial', width: '200px' }}>
                          <div className="table-col">
                            <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                              {s?.code}
                            </div>
                            <small className="info text-uppercase">
                              REF {s?.ref_code}
                            </small>
                            <small className="info text-uppercase">
                              {formatDate(s?.created_at, 'DD/MM/YYYY')}
                            </small>
                          </div>
                          {StateForm?.errors[`shipments.${i}.shipment_customer_id`] ? (
                            <div className="invalid-feedback d-block ">
                              {StateForm?.errors[`shipments.${i}.shipment_customer_id`]}
                            </div>
                          ) : null}
                        </td>
                        <td
                          style={{
                            whiteSpace: 'initial',
                            width: '200px',
                          }}
                        >
                          <div className="table-col">
                            <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                              {s?.pickup_address?.name}
                            </div>
                            <small className="info text-uppercase">
                              {s?.pickup_address?.region?.district_name},{' '}
                              {s?.pickup_address?.region?.regency_name}
                            </small>
                          </div>
                        </td>
                        <td
                          style={{
                            whiteSpace: 'initial',
                            width: '200px',
                          }}
                        >
                          <div className="table-col">
                            <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                              {s?.recipient?.name}
                            </div>
                            <small className="info text-uppercase">
                              {s?.recipient?.region?.district_name},{' '}
                              {s?.recipient?.region?.regency_name}
                            </small>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {StateForm?.errors?.shipments ? (
                <div className="invalid-feedback d-block ">
                  {StateForm?.errors?.shipments}
                </div>
              ) : null}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
